import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { getFileUploadTypes, matchPhrases } from '../../../utils/utilities';
import { getAffirmativeOptions } from '../../../utils/data';
import { IMAGE_LIMITS } from '../../../utils/constants';

import toastService from '../../../services/toastService';

class FVIStructurePIDImageForm extends Form {
	state = {
		data: {
			hasPID: 'yes',
			pIDNumber: '',
			pIDImages: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		hasPID: Joi.string().min(2).required().label('Has P&ID'),
		pIDNumber: Joi.any().when('hasPID', {
			is: 'yes',
			then: Joi.string().min(2).required().label('P&ID Number'),
			otherwise: Joi.string().allow('').label('P&ID Number'),
		}),
		pIDImages: Joi.any().when('hasPID', {
			is: 'yes',
			then: Joi.array().min(1).max(IMAGE_LIMITS.PID_IMAGE).required().label('P&ID Image'),
			otherwise: Joi.array().required().label('P&ID Image'),
		}),
	};

	static propTypes = {
		initialPIDData: PropTypes.object,
		onAdd: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialPIDData) {
			this.setState({ data: this.props.initialPIDData });
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		toastService.success('P&ID Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderSelect({
					name: 'hasPID',
					placeholder: 'Does this structure have a P&ID?',
					label: 'P&ID:',
					options: getAffirmativeOptions(),
				})}

				<Conditional isVisible={matchPhrases(this.state.data.hasPID, 'yes')}>
					<div className="my-4 divider"></div>

					{this.renderInput({
						type: 'text',
						name: 'pIDNumber',
						placeholder: 'Enter P&ID Number',
						label: 'P&ID Number',
					})}

					<div className="my-4 divider"></div>

					{this.renderFileInput({
						max: IMAGE_LIMITS.PID_IMAGE,
						hideCaption: true,
						multiple: IMAGE_LIMITS.PID_IMAGE > 1,
						name: 'pIDImages',
						accept: 'image/*,application/pdf',
						label: 'P&ID',
						sublabel: 'Upload P&ID Image',
						types: getFileUploadTypes(),
					})}
				</Conditional>

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save P&ID')}
				</div>
			</form>
		);
	}
}

export default FVIStructurePIDImageForm;
